import { motion, type HTMLMotionProps } from "framer-motion";
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

type CyberPanelProps = Omit<HTMLMotionProps<"section">, "children"> & {
  children?: ReactNode;
};

export function CyberPanel({ className, children, ...props }: CyberPanelProps) {
  return (
    <motion.section
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
      className={cn(
        "relative min-w-0 overflow-hidden rounded-panel border border-cyan-300/20 bg-surface-raised/80 p-4 shadow-panel backdrop-blur sm:p-5",
        "before:absolute before:inset-x-0 before:top-0 before:h-px before:bg-gradient-to-r before:from-transparent before:via-cyan-300 before:to-transparent",
        className,
      )}
      {...props}
    >
      <div className="relative">{children}</div>
    </motion.section>
  );
}
